module.exports = __webpack_public_path__ + "3aba6c9cd496e6b688b595e6de21fa2d.jpeg";